import API from "./index"

export default {
  findAll(params) {
    return API.get("api/atas", { params });
  },
  findById(id) {
    return API.get(`api/atas/${id}`);
  },
  create(ata) {
    return API.post("api/atas", ata);
  },
  update(id, ata) {
    return API.put(`api/atas/${id}`, ata);
  },
  delete(id) {
    return API.delete(`api/atas/${id}`);
  },
  findItensByAtaId(id) {
    return API.get(`api/itensata/${id}/ata`);
  },
  getProdutosByAtaIdPaged(id, params) {
    return API.get(`api/itensata/${id}/paged`, { params });
  },
  findParticipantesByAtaId(id) {
    return API.get(`api/atas/${id}/participantes`);
  }
};
